import { $, $$, isTablet } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-login-header]')) return;

  mobileMenu();
  selectLanguage();
  updateImage();
  datalayerHeaderLinks();

  window.addEventListener('load', updateImage);
  window.addEventListener('resize', updateImage);
}

function mobileMenu() {
  const openMenu = $('[data-au-login-header-open');
  const closeMenu = $('[data-au-login-header-close');

  openMenu.addEventListener('click', (e) => {
    const trigger = e.target,
      linksContainer = trigger.closest('[data-au-login-header]').querySelector('[data-au-login-header-links]');

    linksContainer.classList.add('au-login-header__right--open');
  });

  closeMenu.addEventListener('click', (e) => {
    const trigger = e.target,
      linksContainer = trigger.closest('[data-au-login-header]').querySelector('[data-au-login-header-links]');

    linksContainer.classList.remove('au-login-header__right--open');
  });

  isTablet.addEventListener('change', () => {
    const linksContainer = $('[data-au-login-header]').querySelector('[data-au-login-header-links]');
    linksContainer.classList.remove('au-login-header__right--open');
  });
}

function selectLanguage() {
  const links = $$('[data-au-login-header-language]');

  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.classList.contains('au-login-header__language-link--inactive')) {
        links.forEach((l) => l.classList.toggle('au-login-header__language-link--inactive'));
      }
    });
  });
}

function updateImage() {
  const linkLogoImg = $('[data-au-login-header]').querySelector('[data-au-login-header-logo-img]');

  if (isTablet.matches) {
    linkLogoImg.src = 'images/layout/logo.svg';
  } else {
    linkLogoImg.src = 'images/layout/logo-white.svg';
  }
}

function datalayerHeaderLinks() {
  $$('[data-au-login-header-language]').forEach((language) => {
    language.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `login_${removeAccentMarkAndUppercase(clickText)}`;
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  });

  $('[data-au-login-header-help]').addEventListener('click', (e) => {
    e.preventDefault();
    const el = e.currentTarget;
    const clickText = el.querySelector(':not([data-au-icon])').innerText;
    const item_id = `login_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });
}
export default { init };
